import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconButton, Grid, TextField, Typography } from '@mui/material/';
import { SearchOutlined } from '@mui/icons-material';
import { BEARS } from '@api';
import HoneywoodLogo from '@assets/Header/honeywood_logo.png';
import styles from './header.module.scss';

const Header = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const [address, setAddress] = useState('');

  const SearchClick = () => {
    (async () => {
      try {
        const bearName = await BEARS.getBearName(address);
        const bearsInfo = await BEARS.getBearsInfo({
          ids: [bearName?.bearId],
        });
        if (bearsInfo?.length && bearsInfo[0].owner) {
          setAddress(bearsInfo[0].owner);
          navigate(`/address/${bearsInfo[0].owner}`, {
            state: { address: bearsInfo[0].owner },
          });
        } else {
          navigate(`/address/${address}`, { state: { address } });
        }
      } catch (error) {
        navigate(`/address/${address}`, { state: { address } });
      }
    })();
  };
  const onKeyHandle = (event) => {
    if (event.charCode === 13 && event.target.value !== '') {
      SearchClick();
    }
  };
  const onChangeAddress = (event) => {
    setAddress(event.target.value.toLowerCase());
  };
  return (
    <Grid
      container
      sx={{
        p: { xs: '8px 50px', sm: '16px 50px', md: '16px 130px' },
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: { xs: 'center', sm: 'space-between' },
        alignItems: 'center',
      }}
      className={styles.MainContainer}
    >
      <div className={styles.LogosContainer}>
        <a href="https://honeywood.io/">
          <img src={HoneywoodLogo} alt="honeywood_logo" className={styles.HoneywoodLogo} />
        </a>
        <div className={styles.Border} />
        <a href="/" className={styles.ExplorerLink}>
          <p className={styles.ExplorerCaption}>Explorer</p>
        </a>
      </div>
      <TextField
        id="textField-header"
        variant="outlined"
        placeholder="Search Address / Nickname ..."
        onChange={onChangeAddress}
        onKeyPress={onKeyHandle}
        className={styles.TextField}
        InputProps={{
          endAdornment: (
            <IconButton onClick={SearchClick} size="large">
              <SearchOutlined />
            </IconButton>
          ),
        }}
        sx={{
          width: '100%',
          maxWidth: { xs: '230px', md: '340px' },
          display: location.pathname === '/' ? 'none' : 'inherit',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none',
            },
          },
          '& .MuiButtonBase-root': {
            color: '#F2A71E',
          },
        }}
      />
    </Grid>
  );
});

export default Header;
